import {
  dataSearch,
  isMounted,
  pagingSearch,
} from '../../helpers/getter-commons';

// algos universal
export const getAlgosUniversal = (state) =>
  dataSearch(state.algosUniversal.list.data, {
    list: true,
  });
export const isAlgosUniversalFetching = (state) =>
  state.algosUniversal.list.isFetching;
export const isAlgosUniversalMounted = (state) =>
  isMounted(state.algosUniversal.list.data);
export const getAlgosUniversalPaging = (state) =>
  pagingSearch(state.algosUniversal.list.data);

// user by id
export const getAlgoUniversalById = (state) =>
  dataSearch(state.algosUniversal.selected.data);
export const isAlgoUniversalByIdFetching = (state) =>
  state.algosUniversal.selected.isFetching;
export const isAlgoUniversalByIdMounted = (state) =>
  isMounted(state.algosUniversal.selected.data);
export const algoUniversalByIdError = (state) =>
  state.algosUniversal.selected.errorMessage;
